//
//
//
//
//
//
//
//

export default {
    name: 'ContainerFluid',

    props: ['fullHheight'],

    data(){ return {
        style: '',
    }},

    mounted(){
        if(this.fullHeight)
          this.style = this.style + 'height: 100%;'
    }

}
